import { render, staticRenderFns } from "./FeaturePlans.vue?vue&type=template&id=b9917a24&scoped=true"
import script from "./FeaturePlans.vue?vue&type=script&lang=js"
export * from "./FeaturePlans.vue?vue&type=script&lang=js"
import style0 from "./FeaturePlans.vue?vue&type=style&index=0&id=b9917a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9917a24",
  null
  
)

export default component.exports